import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentApiService } from '@uc/utilities';
import { SelectOption } from '@uc/web/shared/data-models';

@Injectable({ providedIn: 'root' })
export class AdviceApiService {
	constructor(
		private _http: HttpClient,
		private _apiSrv: EnvironmentApiService,
	) {}

	getAdviceCategories() {
		return this._http.get<SelectOption[]>(
			this._apiSrv.PHP_URL + 'Articles/art_cat_get.php',
		);
	}

	getAllArticles() {
		return this._http.get<any>(this._apiSrv.PHP_URL + 'Articles/uc_arts_get.php');
	}

	getFeaturedArticle(categoryId?: number) {
		const params = {
			cat_id: categoryId ?? null,
		};

		return this._http.post<any>(
			this._apiSrv.PHP_URL + 'Articles/uc_art_get_featured_editor.php',
			params,
		);
	}

	/*
	category search is not implemented on live site
	however functionality is present with backend
	so left params in case category search needs to be readded.
	*/

	searchArticles(
		search: string,
		// category: number | string,
		page: number,
		offset: number,
	) {
		const params = {
			// cat_id: category === '' ? 0 : category,
			search: search ? [search] : '',
			page: page, //will return page * 20 (default is 1)
			offset: offset, //0, no offset, 1 offset -> only return 20 from starting page.
		};

		return this._http.post(
			this._apiSrv.PHP_URL + 'Articles/uc_arts_search.php',
			params,
		);
	}
}
